import { DataGridAlphaV3 as DataGrid } from "../../DataGridAlphaV3";
import { type DataGridProps } from "../../DataGridAlphaV3/Props";

export const DataGridAlphaV3: React.FC<DataGridProps<unknown, unknown>> = (props) => {
	return <DataGrid {...props} />;
};
